import answerDetail from 'page/qa/answerDetail.vue'
import questionDetail from 'page/qa/questionDetail.vue'

export default [
  {
    path: '/qa/answer-:id',
    component: answerDetail,
    meta: {
      pageName: '回答详情页',
      business: '平台',
      title: '回答详情页'
    }
  },
  {
    path: '/qa/:id(\\d+)',
    component: questionDetail,
    meta: {
      pageName: '问题详情页',
      business: '平台',
      title: '问题详情页'
    }
  }
]
